import { render, staticRenderFns } from "./terms_and_conditions_modal.vue?vue&type=template&id=39ab0ef7"
import script from "./terms_and_conditions_modal.vue?vue&type=script&lang=js"
export * from "./terms_and_conditions_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports